import React, { useState } from 'react'
import PotentialLabel from '../PotentialLabel/PotentialLabel'
import { usePotential } from '../PotentialContext/PotentialContext';
import { isValidDecimalInput } from '../../../helper/helpers';
import { formatFixedDecimalPlaces, handlePercentValueLabelChange } from '../utils/helpers';
import PotentialInput from '../PotentialInput/PotentialInput';

const InternalRateOfReturn = () => {
    const { userInfo, updateUserInfo } = usePotential();
    const { internalReturnRate } = userInfo;
    const irr = formatFixedDecimalPlaces(internalReturnRate, 2);
    const [interestRate, setInterestRate] = useState(irr);
    
    const handleOnChange = (e) => {
        const withinReasonableIRR = 50
        const value = e.target.value;
        const isValidDecimal = isValidDecimalInput(value);
        const isValidRange = value <= withinReasonableIRR;
        if(!isValidDecimal || !isValidRange) return;

        setInterestRate(value);

        updateUserInfo({ internalReturnRate: value })
    }

    return (
        <PotentialLabel 
            label={"Internal Return Rate"}
            value={handlePercentValueLabelChange(interestRate)}
        >
            <PotentialInput value={interestRate} handleOnChange={handleOnChange} />
        </PotentialLabel>
    )
}

export default InternalRateOfReturn